import { Component } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { NgForm } from '@angular/forms';
import { CloudinaryOptions, CloudinaryUploader } from 'ng2-cloudinary';
import {AngularFireDatabase, FirebaseListObservable, FirebaseObjectObservable} from 'angularfire2/database';
import { ToastrService } from 'toastr-ng2';

@Component({
  selector: 'app-view-order',
  templateUrl: './view-order.component.html',
  styleUrls: ['./view-order.component.scss']
})
export class ViewOrderComponent{
p:any;
userDetails:any={};
address:any;
orderDetails:any={};
ordersdata: FirebaseObjectObservable<any>;
  constructor(private route: ActivatedRoute,  public router: Router, public af: AngularFireDatabase,public toastr: ToastrService) {
  	 	 	this.route.params.map(params => params['id']).subscribe((Id) => {
  	 	        if(Id != null) {
		        this.ordersdata = this.af.object('/orders/' + Id);
		        this.ordersdata.subscribe(
		        (response) => {  
		        	this.orderDetails = response;
              this.userDetails= response.userDetails;
              this.address=response.shippingAddress;
               console.log(JSON.stringify(this.address))
		         }
		      )
          }
       });
  }
}


// WEBPACK FOOTER //
// /Users/sooweeseng/Documents/Ionic Apps/ShunFa/ShunFa-Restaurant Backend/Restaurant_Firebasebackend/webapp/src/app/routes/restaurant/orders/view-order/view-order.component.ts